import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Formik } from 'formik'
import PaginationComponent from '../../../../components/pagination/pagination.component'
import InnerPageComponent from '../../../../components/layout/private/inner-page-container.component'
import PeriodInputs, {
	periodInitialValues
} from '../../../../components/form-components/period-inputs.component'
import Button from '../../../../components/buttons/buttons.component'
import Title from '../../../../components/typography/title.component'
import { ClientReportsService } from '../../../../services/client-reports.service'
import { AdminService } from '../../../../services/admin.service'
import { StyledFields } from './styles/fields.style'
import { routes } from '../../../../constants/routes.constants'
import { GRAY } from '../../../../styles/colors.style'

class PayHistoryPage extends Component {
	state = {
		values: { ...periodInitialValues, product: '' }
	}

	componentWillMount() {
		AdminService.getProductOptions().then(({ data: productOptions }) =>
			this.setState({
				productOptions: [{ value: '', label: 'Todos' }, ...productOptions]
			})
		)
	}

	componentDidMount() {
		this.refs.pagination.reload()
	}

	onSubmit = values => {
		this.setState({ values })
		this.refs.pagination.reload()
	}

	renderRow = (rowData, headers) => {
		const isPaymentPending = status => status == 'Em atraso'

		return headers.map(({ key, align }) => {
			const onClick = () =>
				key == 'status' &&
				isPaymentPending(rowData[key]) &&
				this.props.history.push(
					`${routes.CLIENTE}/regularizar-assinatura`,
					{
						billingId: rowData.billingId
					}
				)

			const renderCellContent = () => {
				switch (key) {
					case 'planDescription':
						return `Plano ${rowData[key] || ''}`
					case 'status':
						return rowData.status == 'Em atraso' ? (
							<span className={'underline'}>{'Regularizar'}</span>
						) : (
							rowData.status
						)
					default:
						return rowData[key] || ''
				}
			}

			return (
				<td key={key} align={align}>
					<span
						title={rowData[key]}
						className={isPaymentPending(rowData.status) ? 'danger' : ''}
						onClick={onClick}>
						{renderCellContent()}
					</span>
				</td>
			)
		})
	}

	render() {
		const { values } = this.state

		return (
			<InnerPageComponent>
				<Title>Histórico de pagamentos</Title>

				<h3 className="orange semi-bold">Filtros</h3>

				<Formik
					onSubmit={this.onSubmit}
					initialValues={values}
					render={props => (
						<form
							noValidate
							onSubmit={props.handleSubmit}
							style={{ marginBottom: '4rem' }}>
							<StyledFields>
								<PeriodInputs {...props} />
							</StyledFields>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									marginBottom: '4rem'
								}}>
								<Link
									style={{ color: `${GRAY}`, fontSize: '18px' }}
									to={`${routes.CLIENTE}/cancelar-assinatura`}>
									Cancelar assinatura
								</Link>
								<Button primary type="submit">
									Consultar
								</Button>
							</div>
						</form>
					)}
				/>
				<PaginationComponent
					ref={'pagination'}
					getData={ClientReportsService.getPayHistory}
					headers={[
						{ header: 'Data da Cobrança', key: 'billingDate' },
						{ header: 'Descrição', key: 'planDescription' },
						{ header: 'Valor', key: 'value', align: 'right' },
						{ header: 'Pontos', key: 'points', align: 'center' },
						{ header: 'Situação', key: 'status' }
					]}
					showAlert={rows =>
						rows.filter(row => row.status == 'Em atraso').length
					}
					alertText="*Existem pendências na sua assinatura. Clique no item para efetuar o pagamento e regularizar sua assinatura"
					params={{
						dateStart: values.initialDate,
						dateEnd: values.finalDate,
						sidx: 'billingDate',
						sord: 'DESC'
					}}
					rowsPerPage={100}
					renderRow={this.renderRow}
				/>
			</InnerPageComponent>
		)
	}
}

const connectedPayHistoryPage = withRouter(connect(null)(PayHistoryPage))

export { connectedPayHistoryPage as ModuleRootComponent }
